const fontFamily = {
	base: `"Libre Franklin", helvetica, arial, sans-serif`,
	alt: `"Castoro", garamond, serif`,
};

const fontWeight = {
	regular: "400",
	medium: "500",
	semiBold: "700",
	bold: "900",
};

const Typography = {
	fontFamily,
	fontWeight,
};

export default Typography;
